import { List } from "../../../ppui";
import { ListIcon, ListItem, ListText } from "../../../ppui/list";
import { ContentForm, ContentLayout, ContentMenu, ContentMenuSticky, ContentWrapper } from "../../style";
import { MENU_ITEMS } from "./organization-constant";
import OrganizationStickyHeader from "./organization-sticky-header";
import useOrganizationView from './organization.service';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

const OrganizationView = () => {
    const {
        basicInformation,
    } = useOrganizationView()

    const navigate = useNavigate();
    const location = useLocation();
    const { orgId } = useParams();

    const menuItems = MENU_ITEMS(orgId);

    return <>
        <ContentLayout>

            {basicInformation?.org_name &&
                <OrganizationStickyHeader orgDetails={basicInformation}
                />
            }
            <ContentWrapper>
                <ContentMenu>
                    <ContentMenuSticky>
                        <List
                            size={"md"}
                            color={"default"}
                            activeColor={"default"}
                            Colorvariant={"dark"}
                            hover={"secondary"}
                            gap={15}
                        >
                            {menuItems?.map((item, index) => (
                                <ListItem
                                    key={index}
                                    onClick={() => {
                                        if (item.shouldDisabledNewUser) {
                                            if (basicInformation?.org_name) {
                                                navigate(item.path); // Add a leading slash for proper navigation
                                            }
                                        } else {
                                            navigate(item.path); // Add a leading slash for proper navigation
                                        }
                                    }}
                                    isActive={location.pathname === item.path}
                                    className={location.pathname === item.path ? "active" : ""}
                                    colorVariant="light"
                                    disabled={
                                        item.shouldDisabledNewUser && !basicInformation?.org_name
                                      }
                                >
                                    <ListIcon>{item.icon}</ListIcon>
                                    <ListText primary={item.primaryText} />
                                </ListItem>
                            ))}
                        </List>


                    </ContentMenuSticky>
                </ContentMenu>
                <ContentForm>
                    <Outlet />
                </ContentForm>
            </ContentWrapper>
        </ContentLayout>
    </>
}

export default OrganizationView;